
import companyAdminApi from 'app/apis/company-admin';

const Types = {
  SEARCH: 'CADMIN_DOMAINS_SEARCH',
};

const Actions = {

  search: (companyId) => {
    const promise = companyAdminApi.domainsSearch(companyId);
    return { type: Types.SEARCH, promise };
  },

};

export {
  Types,
};

export default Actions;
